module.exports = __webpack_public_path__ + "img/fossilImg1.ba4ed528.png";